// src/components/Hero/Hero.js
import React, { useEffect, useState } from 'react';
import Lottie from "lottie-react";
import styles from './Hero.module.css';

const Hero = () => {
  const [animationData, setAnimationData] = useState(null);
  const emailAddress = "sanjeetm@teezash.com";
  const emailSubject = "Inquiry about Smart IOT Solutions";
  const emailBody = "I'm interested in learning more about your Smart IOT Solutions.";

  const handleContactClick = () => {
    const mailtoLink = `mailto:${emailAddress}?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoLink;
  };

  useEffect(() => {
    import('../../animations/your-animation.json')
      .then(data => {
        setAnimationData(data.default);
      })
      .catch(error => {
        console.error('Error loading animation:', error);
      });
  }, []);

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
        <h1>Revolutionizing Safety with Smart IOT Solutions</h1>
        <p>Building a safer tomorrow with innovative technology one home at a time</p>
        <button 
          onClick={handleContactClick}
          className={styles.contactButton}
          aria-label="Contact Us via Email"
        >
          Contact Us
        </button>
      </div>
      <div className={styles.illustration}>
        {animationData && (
          <Lottie 
            animationData={animationData}
            loop={true}
            autoplay={true}
            className={styles.lottieAnimation}
            rendererSettings={{
              preserveAspectRatio: 'xMidYMid slice'
            }}
          />
        )}
      </div>
    </section>
  );
};

export default Hero;